export class DuplicateTaskError extends Error {}
